// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

type SvgProps = {
    width?: number;
    height?: number;
}

const Svg = (props: SvgProps) => (
    <svg
        width={props.width?.toString() || '206'}
        height={props.height?.toString() || '180'}
        viewBox='0 0 206 180'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
    >
        <g clipPath='url(#clip0_4212_99069)'>
            <ellipse
                cx='103.446'
                cy='90'
                rx='89.25'
                ry='89.25'
                fill='var(--center-channel-color)'
                fillOpacity='0.08'
            />
            <path
                d='M3.03955 75.2739L3.03955 88.6614L175.292 88.6614L175.292 102.941L200.728 102.941'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M36.9551 123.021L36.9551 98.924L60.6063 98.924'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <ellipse
                cx='2.23125'
                cy='2.23125'
                rx='2.23125'
                ry='2.23125'
                transform='matrix(1 8.74228e-08 8.74228e-08 -1 0.808594 75.7207)'
                fill='var(--center-channel-color)'
                fillOpacity='0.56'
            />
            <ellipse
                cx='2.23125'
                cy='2.23125'
                rx='2.23125'
                ry='2.23125'
                transform='matrix(1 8.74228e-08 8.74228e-08 -1 34.7236 127.485)'
                fill='var(--center-channel-color)'
                fillOpacity='0.56'
            />
            <ellipse
                cx='2.23125'
                cy='2.23125'
                rx='2.23125'
                ry='2.23125'
                transform='matrix(1 8.74228e-08 8.74228e-08 -1 198.943 105.173)'
                fill='var(--center-channel-color)'
                fillOpacity='0.56'
            />
            <path
                d='M48.9995 65.9045L104.116 23.957C126.174 40.7447 158.777 65.9045 158.777 65.9045V143.552H48.9995V65.9045Z'
                fill='var(--center-channel-bg)'
                stroke='var(--center-channel-color)'
                strokeWidth='1.5'
                strokeLinejoin='round'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M52.2793 66.9705L104.105 27.5273C124.846 43.3128 155.503 66.9705 155.503 66.9705H52.2793ZM155.503 66.9712H52.2793V139.983H155.503V66.9712Z'
                fill='var(--center-channel-color)'
                fillOpacity='0.24'
            />
            <mask
                id='mask0_4212_99069'
                mask-type='alpha'
                maskUnits='userSpaceOnUse'
                x='51'
                y='34'
                width='106'
                height='73'
            >
                <path
                    d='M104.109 106.959L51.6807 67.689V34.6665H156.103V67.689C156.103 67.689 125.091 91.2429 104.109 106.959Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_4212_99069)'>
                <rect
                    x='138.396'
                    y='38.9854'
                    width='99.3525'
                    height='69.0075'
                    transform='rotate(90 138.396 38.9854)'
                    fill='var(--center-channel-bg)'
                    stroke='var(--center-channel-color)'
                    strokeWidth='1.5'
                />
            </g>
            <path
                d='M104.338 89.596C112.717 89.596 119.51 82.803 119.51 74.4235C119.51 66.0439 112.717 59.251 104.338 59.251C95.958 59.251 89.165 66.0439 89.165 74.4235C89.165 82.803 95.958 89.596 104.338 89.596Z'
                fill='#3DB887'
            />
            <path
                d='M97.5586 74.75L102.456 79.175L111.809 69.5'
                stroke='var(--center-channel-bg)'
                strokeWidth='1.785'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M104.107 106.908L156.994 66.7969V142.659H50.7866V66.7969L104.107 106.908Z'
                fill='var(--center-channel-bg)'
            />
            <path
                d='M51.6797 67.689L104.108 106.959C125.09 91.2429 156.102 67.689 156.102 67.689'
                stroke='var(--center-channel-color)'
                strokeWidth='1.5'
                strokeLinejoin='round'
            />
            <path
                d='M130.559 147.751L102.809 147.751'
                stroke='var(--center-channel-color)'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M98.3091 147.751L89.3091 147.751'
                stroke='var(--center-channel-color)'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M84.8091 147.751L81.8091 147.751'
                stroke='var(--center-channel-color)'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M45.2648 45.5696L53.3086 53.5975V14.7079C53.3086 13.722 52.5094 12.9229 51.5236 12.9229H15.411C14.4251 12.9229 13.626 13.722 13.626 14.7079V43.7846C13.626 44.7705 14.4251 45.5696 15.411 45.5696H45.2648Z'
                fill='#CCC4AE'
            />
            <path
                d='M23.5439 22.8438H35.4487'
                stroke='var(--center-channel-color)'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M23.5439 27.8047H45.3694'
                stroke='var(--center-channel-color)'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M23.5439 33.7559H32.4725'
                stroke='var(--center-channel-color)'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M34.457 33.7559H43.3856'
                stroke='var(--center-channel-color)'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M158.29 51.2478L146.288 63.2261V4.32113C146.288 3.3353 147.087 2.53613 148.073 2.53613H203.712C204.698 2.53613 205.497 3.33531 205.497 4.32114V49.4628C205.497 50.4487 204.698 51.2478 203.712 51.2478H158.29Z'
                fill='#28427B'
            />
            <path
                d='M161.091 17.3379H178.854'
                stroke='white'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M161.091 24.7402H193.656'
                stroke='white'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M161.091 33.6211H174.413'
                stroke='white'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <path
                d='M177.374 33.6211H190.696'
                stroke='white'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
            <rect
                x='89.3086'
                y='45.75'
                width='29.25'
                height='6.75'
                rx='2.25'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <path
                d='M54.0586 78V138H87.8086M90.8086 138H96.8086M99.8086 138H102.809'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
        <defs>
            <clipPath id='clip0_4212_99069'>
                <rect
                    width='204.383'
                    height='178.5'
                    fill='white'
                    transform='translate(0.808594 0.75)'
                />
            </clipPath>
        </defs>
    </svg>
);

export default Svg;

